import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { AzureTableDataset } from 'app/model/dataset/azure-table.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AzureTableDatasetAdapter extends TabularTypeDatasetAdapter<AzureTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureTableDataset): Promise<AzureTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, AzureTableDataset.MODEL);
    }
}
